import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  const { t } = useTranslation('homepage');
  const { ref, isVisible } = useScrollAnimation();

  const features = [
    'zeroContract',
    'verifiedPractitioners',
    'healingFramework',
    'domainFiltering',
    'modalityDatabase',
    'aiAssessment',
    'progressTracking',
  ];

  return (
    <section
      ref={ref}
      className={`py-16 md:py-24 bg-white transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-brand text-foreground">
            <span className="text-gold-ink">Resonow</span> {t('comparisonTitle')}
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl overflow-hidden shadow-lg border border-border">
            {/* Table Header */}
            <div className="grid grid-cols-[1fr,100px,100px] md:grid-cols-[1fr,120px,120px]">
              <div className="bg-muted/50 p-4" />
              <div className="bg-brand-500 p-4 text-center">
                <span className="text-white font-bold text-sm md:text-base">
                  {t('comparisonResonow')}
                </span>
              </div>
              <div className="bg-gray-200 dark:bg-gray-700 p-4 text-center">
                <span className="text-gray-700 dark:text-gray-300 font-bold text-sm md:text-base">
                  {t('comparisonOthers')}
                </span>
              </div>
            </div>

            {/* Table Body */}
            {features.map((feature, index) => (
              <div
                key={feature}
                className={`grid grid-cols-[1fr,100px,100px] md:grid-cols-[1fr,120px,120px] ${
                  index % 2 === 0 ? 'bg-background' : 'bg-warm-50 dark:bg-warm-900/20'
                }`}
              >
                <div className="p-4 flex items-center border-t border-border">
                  <span className="text-sm md:text-base text-foreground">
                    {t(`comparisonFeatures.${feature}`)}
                  </span>
                </div>
                <div className="p-4 flex items-center justify-center border-t border-border bg-warm-50/50 dark:bg-warm-900/10">
                  <div className="w-7 h-7 rounded-full bg-semantic-success flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                </div>
                <div className="p-4 flex items-center justify-center border-t border-border">
                  <X className="w-6 h-6 text-semantic-error" strokeWidth={2.5} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
